import React from "react";
import ReactDOM from "react-dom/client";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "aos/dist/aos.css";
import "react-datepicker/dist/react-datepicker.css";
import "animate.css";
import "boxicons/css/boxicons.min.css";

import { Provider } from "react-redux";
import { persistor, store } from "./Store";
import { PersistGate } from "redux-persist/integration/react";

import { BrowserRouter } from "react-router-dom";
import App from "./App";

import AuthenticateProvider from "./Context/AuthenticateProvider"; 

import "./Assets/css/global.css";
import "./Assets/css/responsive.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <AuthenticateProvider>
          <App />
        </AuthenticateProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
